import { cx } from "@suse-o11y/class-variance";
import { IconChevronDown } from "@suse-o11y/icons";
import React from "react";

import { Button, type ButtonProps } from "~/components/button";

export interface MainMenuAccordionButtonProps extends ButtonProps {
	open: boolean;
}

export const MainMenuAccordionButton: React.FC<MainMenuAccordionButtonProps> = ({ className, open, ...props }) => (
	<Button
		{...props}
		className={cx("size-6 rounded-full bg-grey-200 p-1 leading-none hover:text-primary-500", className)}
		icon
	>
		<IconChevronDown className={cx("h-4 w-4 transition-all", open ? "translate-y-px" : "-translate-y-px rotate-180")} />
	</Button>
);
